import styled from 'styled-components';

import EloLogoSvg from '../../../assets/logos/logo-payment-elo.svg?react';
import MasterCardLogoSvg from '../../../assets/logos/logo-payment-mastercard.svg?react';
import PixLogoSvg from '../../../assets/logos/logo-payment-pix.svg?react';
import TetherLogoImage from '../../../assets/logos/logo-payment-tether.png';
import VisaLogoSvg from '../../../assets/logos/logo-payment-visa.svg?react';
import {
  TIP_CHECKOUT_PAYMENT_METHODS,
  type TipCheckoutPaymentMethod,
} from '../model';

const PaymentMethodsRow = styled.div.attrs({
  'data-ui': 'tips-checkout-payment-methods',
})`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.scale.px(3)};
`;

const PaymentMethodBadge = styled.span<{ $widthPx: number }>`
  width: ${({ $widthPx, theme }) => theme.scale.px($widthPx)};
  height: ${({ theme }) => theme.scale.px(24)};
  border-radius: ${({ theme }) => theme.scale.px(4)};
  background: ${({ theme }) => theme.colors.surface.base};
  box-shadow: 0 ${({ theme }) => theme.scale.px(1)}
    ${({ theme }) => theme.scale.px(3)} rgba(0, 0, 0, 0.1);
  display: grid;
  place-items: center;
`;

const sharedLogoStyles = `
  display: block;
`;

const VisaLogo = styled(VisaLogoSvg)`
  ${sharedLogoStyles}
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(8)};
`;

const MasterCardLogo = styled(MasterCardLogoSvg)`
  ${sharedLogoStyles}
  width: ${({ theme }) => theme.scale.px(26)};
  height: ${({ theme }) => theme.scale.px(15)};
`;

const EloLogo = styled(EloLogoSvg)`
  ${sharedLogoStyles}
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(10)};
`;

const PixLogo = styled(PixLogoSvg)`
  ${sharedLogoStyles}
  width: ${({ theme }) => theme.scale.px(30)};
  height: ${({ theme }) => theme.scale.px(10)};
`;

const TetherLogo = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
  src: TetherLogoImage,
})`
  width: ${({ theme }) => theme.scale.px(47)};
  height: ${({ theme }) => theme.scale.px(15)};
  display: block;
  object-fit: contain;
`;

const paymentMethodBadgeWidthPx: Record<TipCheckoutPaymentMethod, number> = {
  elo: 35,
  mastercard: 35,
  pix: 35,
  tether: 53,
  visa: 35,
};

const paymentMethodLogoByKind: Record<TipCheckoutPaymentMethod, JSX.Element> = {
  elo: <EloLogo />,
  mastercard: <MasterCardLogo />,
  pix: <PixLogo />,
  tether: <TetherLogo />,
  visa: <VisaLogo />,
};

export function TipCheckoutPaymentMethods() {
  return (
    <PaymentMethodsRow aria-hidden>
      {TIP_CHECKOUT_PAYMENT_METHODS.map(paymentMethod => (
        <PaymentMethodBadge
          $widthPx={paymentMethodBadgeWidthPx[paymentMethod]}
          key={paymentMethod}
        >
          {paymentMethodLogoByKind[paymentMethod]}
        </PaymentMethodBadge>
      ))}
    </PaymentMethodsRow>
  );
}
